// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: "/auth/me",
  loginEndpoint: "/jwt/login",
  registerEndpoint: "/jwt/register",
  storageTokenKeyName: "Marsool-landing-page-accessToken",
  storageUserDataKeyName: "Marsool-landing-page-userData",
};
